module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 function isActive(name){
	return obj.order_by === name ? 'is-active' : '';
} 
__p+='\n\n<div class="column column-1 js-order-by pointer player-column player-data-column '+
((__t=( isActive('name') ))==null?'':_.escape(__t))+
'" data-order-by="name">\n	<figure>\n		<picture>\n			<source srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n			<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: id, size: 100 }) ))==null?'':_.escape(__t))+
'" alt="">\n		</picture>\n	</figure>\n	<div class="player-info">\n		<div class="player-name">\n			<i class="player-status '+
((__t=( status ))==null?'':_.escape(__t))+
'"></i>\n			<span>'+
((__t=( first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( last_name ))==null?'':_.escape(__t))+
'</span>\n		</div>\n		<div class="player-stats">\n			<span class="player-opponent">\n				<b>'+
((__t=( squad.short_name ))==null?'':_.escape(__t))+
'</b> '+
((__t=( opponents.symbol ))==null?'':_.escape(__t))+
' '+
((__t=( opponent.short_name ))==null?'':_.escape(__t))+
'\n			</span>\n			<span> | </span>\n			<span class="player-positions">\n				'+
((__t=( position_names.join(', ') ))==null?'':_.escape(__t))+
'\n			</span>\n			<br>\n			<span class="player-cost">\n				'+
((__t=( _.currencyFormat(cost) ))==null?'':_.escape(__t))+
'\n			</span>\n			<span>&nbsp;|&nbsp;</span>\n			<span class="'+
((__t=( cost_season_diff > 0 ? 'positive' : '' || cost_season_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n				'+
((__t=( _.currencyFormat(cost_season_diff, '$', true) ))==null?'':_.escape(__t))+
'\n			</span>\n			<span> </span>\n			(\n			<span class="'+
((__t=( cost_round_diff > 0 ? 'positive' : '' || cost_round_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n				'+
((__t=( _.currencyFormat(cost_round_diff, '$', true) ))==null?'':_.escape(__t))+
'\n			</span>\n			)\n		</div>\n	</div>\n</div>\n<div class="column column-2 js-order-by pointer major-stat-column points-column '+
((__t=( is_mobile && mobile_column === 'stats.avg_points' ? '' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( isActive('stats.points_last_round') ))==null?'':_.escape(__t))+
'" data-order-by="stats.points_last_round">\n	<span class="'+
((__t=( is_playing_now ? 'live' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( is_dnp ? 'dnp' : '' ))==null?'':_.escape(__t))+
'">'+
((__t=( _.result(stats, 'points_last_round', '') ))==null?'':_.escape(__t))+
'</span>\n</div>\n';
 if(!is_playing_now){ 
__p+='\n		<div class="column column-3 js-order-by pointer major-stat-column '+
((__t=( is_mobile && mobile_column === 'stats.points_last_round' ? '' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( isActive('stats.avg_points') ))==null?'':_.escape(__t))+
'" data-order-by="stats.avg_points">\n			'+
((__t=( _.result(stats, 'avg_points', 0) ))==null?'':_.escape(__t))+
'\n		</div>\n';
 } 
__p+='\n\n\n';
 _.each(headings, function(item, index) { 
__p+='\n\n<div class="column column-'+
((__t=( index + 4 ))==null?'':_.escape(__t))+
' js-order-by pointer match-stat-column '+
((__t=( item.key === 'TOG' ? '' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( isActive('match_stats.' + item.key) ))==null?'':_.escape(__t))+
'"\n     data-order-by="match_stats.'+
((__t=( item.key ))==null?'':_.escape(__t))+
'">\n	'+
((__t=( _.result(match_stats, item.key, '-') ))==null?'':_.escape(__t))+
'\n	<div class="score '+
((__t=( _.result(match_points, item.key, 0) > 0 ? 'positive' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( _.result(match_points, item.key, 0) < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n		('+
((__t=( _.result(match_points, item.key, '-') ))==null?'':_.escape(__t))+
')\n	</div>\n</div>\n\n';
 }) 
__p+='';
}
return __p;
};
